import React from "react";
import {PacmanLoader} from "react-spinners";

function ProgressBar(props) {
    return (
        <div style={{
            position: 'fixed',
            zIndex: 1000,
            top: 0,
            right: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent background
        }}>
            <PacmanLoader speedMultiplier={2} color={"#faeb43"} size={80}/>
        </div>
    )
}

export default ProgressBar
